<template>
  <div class="input-div">
    <label class="input-label">{{ lableValue }}</label>
    <el-input 
      :placeholder="placeholder"
      :model-value="modelValue" 
      @input="$emit('update:modelValue', $event)"
      clearable 
      style="border-radius: 5px;">
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'InputEl',
  props: {
    lableValue: {
      type: String,
      required: false
    },
    modelValue: { // 使用 modelValue 替代 inputs
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: "请输入内容"
    }
  }
};
</script>

<style scoped>
.input-div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}

.input-label {
  width: 80px;
  margin-right: 10px;
}
</style>